import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userService, CreateUserPayload } from '@services/user';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useCreateUser = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['users', 'create'],
    mutationFn: async (payload: CreateUserPayload) => {
      return await userService.createUser(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      toast.success(tActionMessages.userCreatedSuccessfully);
    },
    onError: (error: any) => {
      console.error('Create user error:', error);
      const errorMessage =
        error?.response?.errors?.[0]?.message ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        error?.toString() ||
        'Failed to create user';
      toast.error(errorMessage);
    },
  });
};

export default useCreateUser;